import React from 'react';
import OfferingExposureComponent from "./OfferingExposureComponent";
import {padCalendar} from "../../../util";

const formatOfferingExposure = (classPeriodOfferings, offeringExposures) => {
	
	for (const offeringExposure of offeringExposures) {
		let offeringObj = classPeriodOfferings.find(element => element.offeringId === offeringExposure.offeringId);
		offeringExposure.date = padCalendar(offeringObj.offeringDate);
		//offeringExposure.exposure = offeringExposure.priceDecline*offeringObj.offeringShares;
		offeringExposure.offeringShares = offeringObj.offeringShares;
		offeringExposure.offeringPrice = offeringObj.offeringPrice;
	}

	return offeringExposures;
};

const getFilingDate = (classPeriodOfferings) => {
	let classPeriodOfferingsNew = classPeriodOfferings.filter(item => item.offeringType === "Filing"); // Removes 3
	return padCalendar(classPeriodOfferingsNew[0].offeringDate);
};
const ClassPeriodTradingStatContainer = (props) => {
	if (!props.classPeriodOfferings || !props.offeringExposures) {
		return <div>Loading</div>
	}

	const data = formatOfferingExposure(props.classPeriodOfferings, props.offeringExposures);

	return (
		<React.Fragment>
			<OfferingExposureComponent offeringExposures={data} filingDate={getFilingDate(props.classPeriodOfferings)} />
		</React.Fragment>
	);

};


export default ClassPeriodTradingStatContainer;



// WEBPACK FOOTER //
// ./src/common/components/OfferingExposure/OfferingExposureContainer.js